import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import React, { useEffect, useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Option, FilterByCallback } from 'react-bootstrap-typeahead/types/types';

export interface ISimpleListItem {
  id: string | number;
  display: string;
}

interface IProps {
  label: string;
  onChange: (selected: Option[]) => void;
  onInputChange?: (text: string) => void;
  options: Option[];
  placeholder?: string;
  disabled?: boolean;
  allowNew?: boolean;
  clearable?: boolean;
  filterBy?: string[] | FilterByCallback;
  defaultSelected?: Option[];
}

// ZeosTypeAhead component
export const ZeosTypeAhead = (props: IProps) => {
  const [selected, setSelected] = useState<Option[]>();
  const [input, setInput] = useState("");

  return (
    <div className="w-full">
      <label className="block text-lg font-sans font-semibold text-zeos-black mb-2">
        {props.label}
      </label>
      <Typeahead
        id="zeos-typeahead"
        inputProps={{ style: { borderRadius: "0.375rem", padding: "0.5rem" } }}
        options={props.options}
        placeholder={props.placeholder || "Select an option..."}
        disabled={props.disabled}
        allowNew={props.allowNew ?? false}
        clearButton={props.clearable}
        filterBy={props.filterBy}
        defaultSelected={props.defaultSelected}
        // selected={selected && [selected]}
        onChange={(selected: Option[]) => {
          props.onChange(selected);
        }}
        onInputChange={(text) => {
          setInput(text);
          props.onInputChange && props.onInputChange(text);
        }}
      />
    </div>
  );
};
